<template>
  <div class="row">

    <div class="col-lg-6 col-xxxl-6 col-md-6">
      <div class="card mb-25 border-0 rounded-0 bg-white expected-earnings-box ">
        <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
          <span class="d-block mb-6 fs-13 text-uppercase fw-medium text-dark-emphasis">
           Nombre d'emplacements
          </span>
          <h4 class="fw-black mb-12 lh-1">{{sommeEmplacement}}</h4>
         <!-- <span class="fw-bold text-success text-badge d-inline-block">
            {{""}}
          <i class="flaticon-up-arrow fs-11 lh-1 position-relative top-1"> </i>
          </span>-->
          <ul class="list ps-0 mb-0 list-unstyled mt-15">
            <li v-for="(abo, index) in abonnemntsParStatus"  :key="index" class="text-muted position-relative fw-medium">
              Emplacement {{ abo.statut }} = <span class="text-black fw-bold">{{abo.nombre}}</span>
            </li>
          </ul>
          <div id="earningChart" class="chart">
            <apexchart
              type="donut"
              height="100"
              :options="earningChart"
              :series="demandes"
            ></apexchart>
          </div>
        </div>
      </div>
    </div>
     <div class="col-lg-6 col-xxxl-6 col-md-6">
      <div class="card mb-25 border-0 rounded-0 bg-white expected-earnings-box ">
        <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
          <span class="d-block mb-6 fs-13 text-uppercase fw-medium text-dark-emphasis">
            Nombre d'usagers
          </span>
          <h4 class="fw-black mb-12 lh-1">{{ somUsager }}</h4>
          <ul class="list ps-0 mb-0 list-unstyled mt-15">
            <li v-for="(boite, index) in boitesParStatus" :key="index" class="text-muted position-relative fw-medium">
              Usagers {{boite.etat}}s = <span class="text-black fw-bold">{{ boite.nombreUsager }}</span>
            </li>
            
          </ul>
          <div id="earningChart" class="chart">
            <!--<apexchart
              type="donut"
              height="100"
              :options="earningChart"
              :series="abonnement"
            ></apexchart>-->
          </div>
        </div>
      </div>
    </div>
  </div>

  
</template>

<script lang="ts">
import { defineComponent,onMounted,ref } from "vue";
  import axios from 'axios';

export default defineComponent({
  name: "ExpectedEarnings",
  data: function () {
    const donnedemandeTypes = ref<Array<number>>([]);
    const totalDem = ref(0);
    //const abonementActif = ref(0);
    onMounted(async() => {
      await getNombreUsagerParStatus();
      await getEmplacementParStatus();
      demandeType.value.forEach((element: any) => {
        totalDem.value += parseInt(element.nombreDemande);
        ajouterNouvellesValeurs(element.nombreDemande);
      });
    });
    function ajouterNouvellesValeurs(valeur:number) {
      donnedemandeTypes.value.push(valeur);
    }
    const totalPayee = ref(0);
    const totalImpaye = ref(0);
    const demandeType = ref([]);
    const chiffreAff = ref(0)
    const abonnemntsParStatus = ref([]);
    const boitesParStatus = ref([]);
    const sommeEmplacement = ref(0);
    const somUsager = ref(0);

    const getNombreUsagerParStatus = async () =>{
      try {
        const response = await axios.get(`/etats/usagers`);
        const valeur = response.data.data;
        boitesParStatus.value = response.data.data;
        valeur.forEach((element: any) => {
          if(element.etat === "Total"){
          somUsager.value = parseInt(element.nombreUsager);
          }
      });
        return boitesParStatus.value;
      }catch (error) { 
        //
      } 
    } 

    const getEmplacementParStatus = async () =>{
      try{ 
        const response = await axios.get(`etats/emplacements`);
        const valeur = response.data.data;
        abonnemntsParStatus.value = response.data.data;
        valeur.forEach((element: any) => {
          if(element.statut === "Emplacement"){
            sommeEmplacement.value = parseInt(element.nombre);
          }
      }); 
        return abonnemntsParStatus.value;
      }catch (error) { 
        //console.log("ERROR EMPLACEMENTS/STATUS ==> ", error);
      }
    }
    return {
     // abonementActif,
      demandeType,
      totalDem,
      chiffreAff,
      abonnemntsParStatus,
      boitesParStatus,
      getNombreUsagerParStatus,
      getEmplacementParStatus,
      sommeEmplacement,
      somUsager,
      donnedemandeTypes,
      demandes: donnedemandeTypes.value,
      abonnement: [60, 30, 20],
      abonnet: [60, 30, 20],
      earningChart: {
        dataLabels: {
          enabled: false,
        },
        colors: ["#6FD3F7","#0a59a4","#f3c148",],
        legend: {
          show: false,
          fontWeight: 500,
          fontSize: "14px",
          fontFamily: "Red Hat Display, sans-serif",
          labels: {
            colors: "#ffffff",
          },
          markers: {
            offsetX: -2,
            offsetY: 1,
          },
        },
        stroke: {
          width: 0,
        },
        tooltip: {
          enabled: false,
          style: {
            fontSize: "14px",
            fontFamily: "Red Hat Display, sans-serif",
          },
        },
      },
    };
  },
});
</script>